export const ADD_WALL = 'ADD_WALL'
export const ADD_NODE = 'ADD_NODE'
export const UPDATE_NODE = 'UPDATE_NODE'

export const WALL_FETCH_REQUEST = 'WALL_FETCH_REQUEST'
export const WALL_FETCH_SUCCESS = 'WALL_FETCH_SUCCESS'
export const WALL_FETCH_FAILURE = 'WALL_FETCH_FAILURE'

export const WALL_ADD_POST_REQUEST = 'WALL_ADD_POST_REQUEST'
export const WALL_ADD_POST_SUCCESS = 'WALL_ADD_POST_SUCCESS'
export const WALL_ADD_POST_FAILURE = 'WALL_ADD_POST_FAILURE'

export const WALL_ADD_EVENT_REQUEST = 'WALL_ADD_EVENT_REQUEST'
export const WALL_ADD_EVENT_SUCCESS = 'WALL_ADD_EVENT_SUCCESS'
export const WALL_ADD_EVENT_FAILURE = 'WALL_ADD_EVENT_FAILURE'
